var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C7.724 16 7.5 15.776 7.5 15.5V1.70733L1.35333 7.854C1.25933 7.948 1.13333 8 1 8C0.866667 8 0.740667 7.948 0.646667 7.85333C0.552 7.75933 0.5 7.63333 0.5 7.5C0.5 7.36667 0.552 7.24067 0.646667 7.14667L7.646 0.146667C7.69267 0.1 7.74733 0.0633333 7.80933 0.038C7.81467 0.036 7.82 0.034 7.826 0.032C7.88333 0.0106667 7.94133 0 8 0C8.05933 0 8.118 0.0106667 8.174 0.032C8.17867 0.0333333 8.18333 0.0353333 8.188 0.0366667C8.25267 0.0633333 8.30733 0.1 8.35467 0.147333L15.3533 7.14667C15.448 7.24067 15.5 7.36667 15.5 7.5C15.5 7.63333 15.448 7.75933 15.3533 7.85333C15.2587 7.94733 15.1333 8 15 8C14.8667 8 14.7407 7.948 14.6467 7.85333L8.5 1.70667V15.5C8.5 15.776 8.276 16 8 16Z",
    fill: "#3C4D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSort);
export default __webpack_public_path__ + "static/media/up-sort.76067bc3c68b125bfc4888e72f9c7334.svg";
export { ForwardRef as ReactComponent };